export const getErrors = (state) => state.devicePorts.errors;
export const getIsFetching = (state) => state.devicePorts.isFetching;
export const getItems = (state) => state.devicePorts.items;
